import { readFileSync } from "fs";
import { fileURLToPath } from "url";
import { dirname, join } from "path";

const __dirname = dirname(fileURLToPath(import.meta.url));
const pkg = JSON.parse(readFileSync(join(__dirname, "../package.json"), "utf-8"));

export const VERSION: string = pkg.version;
export const NAME: string = pkg.name;
export const CLI_CLIENT_ID = "2veBSofhicRBguUT";
